import { useState } from 'react';

interface AvatarProps {
    src?: string | null;
    name?: string | null;
    email?: string | null;
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

/** First letters of first and last name, else of the email, else "?". */
export function getInitials(name?: string | null, email?: string | null): string {
    const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    if (parts.length === 1) {
        return parts[0][0].toUpperCase();
    }
    return email?.trim()[0]?.toUpperCase() || '?';
}

/**
 * Avatar component with automatic fallback to initials
 * Supports image URLs (OIDC or Gravatar) with error handling
 */
export function Avatar({ src, name, email, size = 'md', className = '' }: AvatarProps) {
    const [imageError, setImageError] = useState(false);

    const sizeClasses = {
        sm: 'w-8 h-8 text-xs',
        md: 'w-10 h-10 text-sm',
        lg: 'w-12 h-12 text-base',
    };


    return (
        <div
            className={`
        ${sizeClasses[size]} 
        bg-gray-200 rounded-full flex items-center justify-center overflow-hidden
        ${className}
      `}
        >
            {src && !imageError ? (
                <img
                    src={src}
                    alt={name || 'Avatar'}
                    className="w-full h-full object-cover"
                    onError={() => setImageError(true)}
                    loading="lazy"
                />
            ) : (
                <span className="text-gray-600 font-medium">
                    {getInitials(name, email)}
                </span>
            )}
        </div>
    );
}

export default Avatar;
